<style lang="less">

</style>
<template>
	<v-component v-bind:is="component" :element="element"></v-component>
</template>

<script>
	export default {
		name: "DisplayElement",
		props:{
			element: {type: Object},
		}, 
		components: {
			DisplayCard:  () => import("../TextEditor/DisplayCard"),
			DisplayHr:  () => import("../TextEditor/DisplayHr"),
			DisplayRow:  () => import("../TextEditor/DisplayRow"),
			DisplayText:  () => import("../TextEditor/DisplayText"),
			DisplayButton:  () => import("../TextEditor/DisplayButton"),
		},
		data: () =>{
			return {			

			}
		},
		computed: {
			component(){
				if( this.element.key == "html" ){
					return "DisplayText";
				}
				return this.element.component.replace("Editor", "Display")
			}
		}
	}
</script>